import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Row, Col, ButtonGroup, Button, Card, CardHeader, CardBody, CardTitle, CardText } from 'reactstrap';
import { useParams, Link } from "react-router-dom";
import { PageTitle, ParentListItem, ClassroomListItem } from '../../../components';
import Role from '../../../components/Role/Role';
import Icon from '@mdi/react';
import {
    mdiAccountArrowRightOutline,
    mdiAccountCircleOutline,
    mdiAccountChildOutline,
    mdiAccountGroupOutline,
    mdiCardAccountPhoneOutline,
    mdiCommentAccountOutline,
} from '@mdi/js';

import { Utils } from '../../../services/';
import { loadMember } from '../../../redux/modules/members';

import moment from 'moment';

const MemberShow = () => {
    const { memberId } = useParams();

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadMember(memberId));
    }, [ memberId ]);

    const { t }        = useTranslation();
    const { member }  = useSelector(state => state.members);
    const current_user = useSelector(state => state.auth.user);

    if (!current_user || !member)
        return null;

    const title = current_user.id === member.id ?
        <span>{t('members.my_profile')}</span>
        :
        <span>
            {t('members.member')}
            <small> | { member.firstname } { member.lastname }</small>
        </span>

    const actions =
    <div>
        <ButtonGroup>
            <Role has="admin">
                <Button tag={Link} to={ -1 } color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}
                </Button>
            </Role>
            {member &&
                <Button tag={Link} to={ `/members/edit/${ member.id }` } color="info" size="sm">
                    <i className="fa fa-edit"></i>&nbsp;{t('common.edit')}
                </Button>
            }
        </ButtonGroup>
    </div>

    return (
        <div className="MemberShow">
            <PageTitle icon="members" title={ title } actions={ actions } />
            {member &&
                <div>
                    <Row className="row-flex">
                        <Col sm={12} lg={6}>
                            <Card color="light" className="h-100">
                                <CardHeader>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiAccountCircleOutline} size={1.5} />
                                        {t('members.profile')}
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <CardText tag="div">
                                        <div><b>{t('members.firstname')}</b>: { member.firstname }</div>
                                        <div><b>{t('members.lastname')}</b>: { member.lastname }</div>
                                        <div><b>{t('members.gender')}</b>: { member.gender }</div>
                                        <div><b>{t('members.birthdate')}</b>: { moment(member.birthdate).format('LL') }</div>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={12} lg={6}>
                            <Card color="light">
                                <CardHeader>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiAccountChildOutline} size={1.5} />
                                        {t('members.parents')}
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <CardText tag="div" className="h-100">
                                        <Row className="row-cols-sm-1 row-cols-lg-1 row-cols-xl-1">
                                        { member?.parents?.map(parent => (
                                            <Col sm="12" md="12" className="mb-1">
                                                <ParentListItem
                                                    parent={ parent }
                                                    condensed
                                                    actions={(
                                                        <>
                                                            <Button tag={Link} to={ `/users/show/${ parent.id }` } color="warning" size="sm">
                                                                <Icon path={mdiAccountArrowRightOutline} size={1} />
                                                            </Button>&nbsp;
                                                        </>
                                                    )}
                                                />
                                            </Col>
                                        ))}
                                        </Row>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="row-flex">
                        <Col sm={12} lg={6}>
                            <Card color="light" className="h-100">
                                <CardHeader>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiAccountGroupOutline} size={1.5} />&nbsp;
                                        {t('members.group')}
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <CardText tag="div">
                                        <CardTitle tag="h4">
                                            { member.group.id && (
                                                <span>
                                                    { member.group.name } -&nbsp;
                                                    <small>{member.group.getAgesText()}</small>
                                                </span>
                                            )}
                                            { !member.group?.id && t('members.has_no_group') }
                                        </CardTitle>
                                        { member.group && member.group.classrooms?.map( classroom => (
                                            <ClassroomListItem
                                                classroom={ classroom }
                                            />
                                        ))}
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={12} lg={6}>
                            <Card color="light" className="h-100">
                                <CardHeader>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiCommentAccountOutline} size={1.5} />&nbsp;
                                        {t('members.other_informations')}
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <CardText tag="div">
                                        <div>{ member.remarks }</div>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            }
        </div>
    );
}

export default MemberShow;
